"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkError = void 0;
function isNetworkError(error) {
    var castError = error;
    return ((castError === null || castError === void 0 ? void 0 : castError.message) !== undefined &&
        (castError === null || castError === void 0 ? void 0 : castError.path) !== undefined &&
        (castError === null || castError === void 0 ? void 0 : castError.status) !== undefined &&
        (castError === null || castError === void 0 ? void 0 : castError.type) !== undefined);
}
exports.isNetworkError = isNetworkError;
//# sourceMappingURL=network.js.map